import { render } from "./SelectButton.vue?vue&type=template&id=3487bac1&scoped=true"
import script from "./SelectButton.vue?vue&type=script&lang=js"
export * from "./SelectButton.vue?vue&type=script&lang=js"

import "./SelectButton.vue?vue&type=style&index=0&id=3487bac1&scoped=true&lang=scss"

import exportComponent from "/builds/dobro/amway-calculator-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3487bac1"]])

export default __exports__